"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _precheckDisclaimer = _interopRequireDefault(require("./common/precheck-disclaimer"));
var _errorFallback = _interopRequireDefault(require("./common/error/error-fallback"));
var _productConfiguration = _interopRequireDefault(require("./common/product-configuration"));
var _summaryWrapper = _interopRequireDefault(require("./common/summary-wrapper"));
var _configContext = require("../context/config-context");
var _loader = _interopRequireDefault(require("./loader"));
/* eslint-disable no-console */

/**
 * Local Imports
 */

const SectionContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SectionContainer",
  class: "pc-sahy9gr"
});
const GridContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GridContainer",
  class: "pc-g1c2ms3d"
});
const ConfigContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ConfigContainer",
  class: "pc-c1jfjmpn"
});
const SummaryContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SummaryContainer",
  class: "pc-sm84cd6"
});

/**
 * PageLayout Component.
 *
 * @param {Object} props React props
 * @returns {React.ReactElement} PageLayout Component
 * @public
 */

function PageLayout() {
  const {
    loading,
    error
  } = (0, _configContext.useConfig)();
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_loader.default, null);
  }
  if (error) {
    console.error('Error in PageLayout:', error?.message);
    return /*#__PURE__*/_react.default.createElement(_errorFallback.default, {
      error: error
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SectionContainer, null, /*#__PURE__*/_react.default.createElement(GridContainer, null, /*#__PURE__*/_react.default.createElement(ConfigContainer, null, /*#__PURE__*/_react.default.createElement(_productConfiguration.default, null)), /*#__PURE__*/_react.default.createElement(SummaryContainer, null, /*#__PURE__*/_react.default.createElement(_summaryWrapper.default, null)))), /*#__PURE__*/_react.default.createElement(_precheckDisclaimer.default, null));
}
var _default = exports.default = PageLayout;
PageLayout.propTypes = {
  itemSummary: _propTypes.default.shape(_summaryWrapper.default.propTypes)
};